import React, { useState, useEffect, useRef } from "react";

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../css/ReportPage.css";

import NavbarTH from "../components/header/Navbar-TH";
import NavbarEN from "../components/header/Navbar-EN";

import BannerTH from "../components/header/Banner-TH";
import BannerEN from "../components/header/Banner-EN";

import MainReportTH from "../components/main/MainReport-TH";
import MainReportEN from "../components/main/MainReport-EN";

import FooterTH from "../components/footer/Footer-TH";
import FooterEN from "../components/footer/Footer-EN";

///////////////// Redux ////////////////////
import { useSelector, useDispatch } from "react-redux";
import { saveDataLatLon } from "../store/MapPositionSlice";

export default function ReportPage() {
  const { language } = useSelector((state) => ({ ...state }));
  const dispatch = useDispatch();

  useEffect(() => {
    getLocation();
  }, []);

  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
    }
  };

  const showPosition = async (position) => {
    let current_coors = {
      lng: position.coords.longitude,
      lat: position.coords.latitude,
    };
    await dispatch(saveDataLatLon(current_coors));
  };

  return (
    <div
      className="container-all"
      style={{
        backgroundColor: "#EFEFEF",
      }}
    >
      <nav>
        {language.toggle_language == true ? <NavbarTH /> : <NavbarEN />}
      </nav>

      <banner>
        {language.toggle_language == true ? <BannerTH /> : <BannerEN />}
      </banner>

      <main>
        {language.toggle_language == true ? <MainReportTH /> : <MainReportEN />}
      </main>

      <footer>
        {language.toggle_language == true ? <FooterTH /> : <FooterEN />}
      </footer>
    </div>
  );
}
